import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { MatDialog } from '@angular/material/dialog';
import { filter, skip, Subscription } from 'rxjs';
import { EstatusJSON } from 'src/app/features/shared/models/EstatusJSON';
import { environment } from 'src/environments/environment';
import { CategoryFiltersDTO } from 'src/app/features/shared/models/CategoryFilters/CategoryFilters';
import { FilterDialogData, FilterDialogResult, SelectedFilter } from '../../../../models/Filters';
import { EnumAlarmCategory, EnumAlarmCategoriesValues, EnumAlarmCategoriesColors, EnumAlarmCategoriesIcons } from 'src/app/features/shared/helpers/enums/EnumAlarmCategories';
import { FilterCategoriesComponent } from '../../organisms/filters/filters-categories/filter-categories.component';
import { LayerDTO } from '../../../../models/LayerDTO';
import { LocationCategoryDTO } from '../../../../models/LocationCategoryDTO';
import { LocationDTO } from '../../../../models/LocationDTO';
import { StatusFlag } from '../../../../models/StatusFlag';
import { PanelInternalLayerService } from '../../../../services/Panel-Internal-Layer.service';
import { PanelLocationsService } from '../../../../services/Panel-Locations.service';

@Component({
  selector: "app-filtered-category-tab",
  templateUrl: "./filtered-category-tab.component.html",
  styleUrls: ["./filtered-category-tab.component.css"],
})
export class FilteredCategoryTabComponent implements OnInit, OnDestroy {
  @Input() filtersObject: FilterDialogData;
  @Input() selectedCategoryItem: LocationCategoryDTO;
  @Output() onLocationLoaded = new EventEmitter<LocationDTO[]>();
  @Output() onCardClickedEmitter = new EventEmitter<LocationDTO>();
  @Output() categoryTotalUpdated = new EventEmitter<{id: number, total: number}>();

  locations: LocationDTO[] = [];
  isLoading: boolean = false;
  hasAppliedFilter: boolean = false;
  filtersSelected: SelectedFilter[] = [];
  currentPage: number = 1;
  isLocationListEnd: boolean = false;
  filterDialog: any;

  selectedFiltersDisplay: string = ""; 

  subscription_AfterClosed: Subscription;
  subscription_GetListFiltered: Subscription;
  subscription_tabCategoryFiltersSelected: Subscription;
  subscription_LocationDataChanged: Subscription;

  constructor(
    public dialog: MatDialog,
    private panelLocationsService: PanelLocationsService,
    private panelInternalLayerService: PanelInternalLayerService
  ) {}

  ngOnInit(): void {
    this.applySavedFilters(this.panelLocationsService.tabCategoryFiltersSelected.value);

    this.subscription_tabCategoryFiltersSelected = this.panelLocationsService.tabCategoryFiltersSelected.pipe(
      skip(1),
      filter(t => t != null && t.categoryToBeAffected?.id == this.selectedCategoryItem.id)
    ).subscribe((selected) => {
      this.applySavedFilters(selected);
    });

    this.subscription_LocationDataChanged = this.panelLocationsService.getLocationDataChanged().subscribe(() => {
      if (this.hasAppliedFilter) {
        this.currentPage = 1;
        this.isLocationListEnd = false;
        this.loadLocationsWithFilter();
      }
    });
  }

  private applySavedFilters(selected: {filters: { id: string, filtersSelected: SelectedFilter[] }[], categoryToBeAffected: LocationCategoryDTO}): void {
    if (!environment.production) console.log("filters", selected);

    const savedFilter = selected?.filters?.find(t => t.id == this.selectedCategoryItem.id.toString());
    if(savedFilter != null && savedFilter.filtersSelected?.length > 0){
      this.filtersSelected = savedFilter.filtersSelected;
      this.selectedFiltersDisplay = this.filtersSelected.map(f => f.value).join(", ");
      this.hasAppliedFilter = true;
      this.currentPage = 1;
      this.isLocationListEnd = false;
      this.loadLocationsWithFilter();
    }else{
      if (this.subscription_GetListFiltered)
        this.subscription_GetListFiltered.unsubscribe();
      this.filtersSelected = [];
      this.selectedFiltersDisplay = "";
      this.hasAppliedFilter = false;
      this.isLoading = false;
      this.currentPage = 1;
      this.isLocationListEnd = false;
      this.locations = [];
      this.onLocationLoaded.emit(this.locations);
    }
  }

  ngOnDestroy(): void {
    if (this.subscription_AfterClosed) {
      this.subscription_AfterClosed.unsubscribe();
    }
    if (this.subscription_GetListFiltered) {
      this.subscription_GetListFiltered.unsubscribe();
    }
    if (this.subscription_tabCategoryFiltersSelected) {
      this.subscription_tabCategoryFiltersSelected.unsubscribe();
    }
    if (this.subscription_LocationDataChanged) {
      this.subscription_LocationDataChanged.unsubscribe();
    }

    if(this.filterDialog != null){
      this.filterDialog.close();
    }
  }

  openFilter(): void {
    if (!environment.production)
      console.log("filtersObject", this.filtersObject);

    // Agregar filtro dummy de Zonas
    // const filtersObjectUnique = { filters: [...this.filtersObject.filters], selected: [...this.filtersObject.selected] };
    // if(filtersObjectUnique.filters.findIndex(f => f.key == "Zones") == -1)
    // filtersObjectUnique.filters.push({
    //   key: "Zones",
    //   selected: "",
    //   values: ["METRO", "MEXICO", "CENTRO", "TOCUILA"],
    //   idLocationCategory: this.selectedCategoryItem.id,
    // });

    this.filterDialog = this.dialog.open(FilterCategoriesComponent, {
      data: {
        moduleName: this.filtersObject.moduleName,
        filters: this.filtersObject.filters,
        idLocationCategory: this.selectedCategoryItem.id,
        selected: this.filtersSelected,
      } as FilterDialogData,
      disableClose: false,
      panelClass: 'locations-filters-custom-popup',
      hasBackdrop: true,
      autoFocus: false,
      restoreFocus: false,
    });

    this.subscription_AfterClosed = this.filterDialog.afterClosed().subscribe((res: FilterDialogResult) => {
      if(!res || !res.search)
        return;

      if (res && res.search && res.filtersSelected?.length > 0) {
        console.log("Filtros seleccionados:", res.filtersSelected);
        
        var allOtherFilters = this.panelLocationsService.tabCategoryFiltersSelected.value.filters.filter(t => t.id != this.selectedCategoryItem.id.toString());
        allOtherFilters.push({ id: this.selectedCategoryItem.id.toString(), filtersSelected: res.filtersSelected });
        this.panelLocationsService.tabCategoryFiltersSelected.next({filters: allOtherFilters, categoryToBeAffected: this.selectedCategoryItem});
        // this.SetSystemLayersOn(this.selectedCategoryItem);
      }else{

        var allOtherFilters = this.panelLocationsService.tabCategoryFiltersSelected.value.filters.filter(t => t.id != this.selectedCategoryItem.id.toString());
        this.panelLocationsService.tabCategoryFiltersSelected.next({filters: allOtherFilters, categoryToBeAffected: this.selectedCategoryItem});
        // this.SetSystemLayersOff(this.selectedCategoryItem);
        this.selectedFiltersDisplay = "";
        this.hasAppliedFilter = false;
        this.isLoading = false;
        this.currentPage = 1;
        this.isLocationListEnd = false;

        this.locations = [];
        this.onLocationLoaded.emit(this.locations);
        this.categoryTotalUpdated.emit({id: this.selectedCategoryItem.id, total: 0});
      }
    });
  }

  loadLocationsWithFilter(page: number = 1): void {
    this.isLoading = true;

    // todo: cambiar a este endpoint, el otro no trae filtrado
    // this.subscription_GetListFiltered = this.panelLocationsService.GetLocationsByPageFilter(filterSelected, this.selectedCategoryItem.id, page)
    //   .subscribe({
    //     next: (data: EstatusJSON) => {
    //       this.handleLocationResponse(data, page);
    //     },
    //     error: (error) => {
    //       this.handleLocationError(error, page);
    //     },
    //   });
    const filters : CategoryFiltersDTO[] = this.filtersSelected.map(f => ({Key: f.key, Value: f.value, Module: f.module || ''}));
    if (this.subscription_GetListFiltered)
      this.subscription_GetListFiltered.unsubscribe();
    this.subscription_GetListFiltered = this.panelLocationsService.GetListByIdLocationCategoryPage(this.selectedCategoryItem.id, page, filters).subscribe({
        next: (data: EstatusJSON) => {
          this.handleLocationResponse(data, page);
        },
        error: (error) => {
          this.handleLocationError(error, page);
        },
    });
  }

  SetSystemLayersOn(category: LocationCategoryDTO) {
    const filters : CategoryFiltersDTO[] = this.filtersSelected.map(f => ({Key: f.key, Value: f.value, Module: f.module || ''}));
    var systemLayer = new LayerDTO();
    systemLayer.name = category.shortName;
    systemLayer.categoryId = category.id;
    if(!environment.production) console.log("capas panel", this.panelInternalLayerService.capas$.value, filters);
    if (this.panelInternalLayerService.capas$.value.length > 0) {
      this.panelInternalLayerService.ActivateLayer(systemLayer, filters);
    }else{
      setTimeout(() => {
        this.panelInternalLayerService.ActivateLayer(systemLayer, filters);
      }, 4000);
    }
  }

  SetSystemLayersOff(category: LocationCategoryDTO) {
    var systemLayer = new LayerDTO();
    systemLayer.name = category.shortName;
    systemLayer.categoryId = category.id;
    if(!environment.production) console.log("capas panel", this.panelInternalLayerService.capas$.value);
    if (this.panelInternalLayerService.capas$.value.length > 0) {
      this.panelInternalLayerService.DeactivateLayer(systemLayer);
      this.panelInternalLayerService.setLayerHasBeenFiltered(systemLayer, false);
    }else{
      setTimeout(() => {
        this.panelInternalLayerService.DeactivateLayer(systemLayer);
        this.panelInternalLayerService.setLayerHasBeenFiltered(systemLayer, false);
      }, 4000);
    }
  }

  private handleLocationResponse(data: EstatusJSON, page: number): void {
    if (data.isSuccess) {

      this.setLocationList(data, page);
      this.currentPage = page;
      if (!environment.production) console.log("Ubicaciones cargadas", this.locations.length, "total");
      
      const categoryId = this.selectedCategoryItem.id;
      const total = data.result?.contador || 0;

      this.categoryTotalUpdated.emit({id: categoryId, total: total});
    } else {
      console.error("Error al cargar ubicaciones", data.message);
      Sentry.captureMessage('UbicacionCategory.handleLocationResponse: isSuccess false', { level: 'warning', extra: { response: data } });
      if (page === 1) {
        this.locations = [];
        this.onLocationLoaded.emit(this.locations);
      }
    }
    this.isLoading = false;
  }

  private handleLocationError(error: any, page: number): void {
    console.error("Error al cargar ubicaciones", error);
    if (page === 1) {
      this.locations = [];
      this.onLocationLoaded.emit(this.locations);
    }
    this.isLoading = false;
  }

  onScroll(event: any): void {
    console.log("ubicacion scroll 1");
    
    if (this.isLocationListEnd || this.isLoading) {
      return;
    }

    console.log("ubicacion scroll 2");

    const element = event.target;
    if (element.scrollHeight - element.scrollTop <= element.clientHeight + 10) {
      this.loadMoreLocations();
    }
  }

   setLocationList(data: any, page : number) {
    if(this.isLocationListEnd || data.result?.listaLocaciones == null){
      return;
    }

    const locationList = data.result.listaLocaciones as LocationDTO[];

    // si ya no hay datos, se termina la busqueda
    if (locationList.length == 0) {
      this.isLocationListEnd = true;
      var empty = new Array<LocationDTO>();
      this.setLocationPage(empty, page);
      return;
    }

    // si hay menos de 20 elementos, se asignan los que hay y termina la busqueda
    if (locationList.length < 20) {
      this.isLocationListEnd = true;
      this.setLocationPage(locationList, page);
      return;
    }

    this.setLocationPage(locationList, page);
  }

  loadMoreLocations(): void {
    if (this.isLocationListEnd || this.isLoading) {
      return;
    }

    const length = this.locations.length;
    const residue = length % 20;
    let nextPage = 0;

    if (residue != 0) {
      nextPage = 1;
    } else {
      nextPage = length / 20 + 1;
    }

    if (!environment.production)
      
    this.loadLocationsWithFilter(nextPage);
  }

  onCardClicked(location: LocationDTO): void {
    this.onCardClickedEmitter.emit(location);
  }

  copyToClipboard(text: string): void {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        if (!environment.production)
          console.log("Copiado al portapapeles:", text);
      })
      .catch((err) => {
        console.error("Error al copiar:", err);
      });
  }

  setLocationPage(result: LocationDTO[], page: number) {
    result.forEach((item) => {
      item.panelIcon = item.icon;

      // item.flagTypes = this.dummyFlagTypes;

      item.statusFlags = item.statusFlags || [];
      item.statusFlags.push(...this.getStatusFlagsByFlagTypes(item.flagTypes));
    });
    if (page == 1) {
      this.locations = result;
      // this.$ItemsGet = this.$Items;
    }

    if (page != 1) {
      this.locations = this.locations.concat(result);
      // this.$ItemsGet = this.$Items;
    }

    this.panelLocationsService.setLoading(false);
  }

  getStatusFlagsByFlagTypes(flagTypes: number[]): StatusFlag[] {
    var statusFlags = [];
    if (flagTypes == null || flagTypes.length < 1) {
      return statusFlags;
    }
    flagTypes.forEach((flagType) => {
      var statusKey = Object.keys(EnumAlarmCategory).find(
        (key) => EnumAlarmCategory[key] === flagType
      );
      if (!environment.production)
        console.log(
          "statusKey",
          statusKey,
          EnumAlarmCategoriesValues[statusKey],
          EnumAlarmCategoriesColors[statusKey]
        );

      if (statusKey) {
        var statusFlag = {
          flagName: EnumAlarmCategoriesValues[statusKey],
          priorityHex: EnumAlarmCategoriesColors[statusKey],
          flagIcon: EnumAlarmCategoriesIcons[statusKey],
        } as StatusFlag;
        statusFlags.push(statusFlag);
      } else {
        return null;
      }
    });
    return statusFlags;
  }
}
